//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('requisitions', {
//        templateUrl: 'views/components/views/requisitions/requisitions.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'requisitionsService', 'logisticService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, requisitionsService, logisticService, ttGridFactory, rememberService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                businessco_no_from: '',
//                stockplace_id_from: '',
//                businessco_no_to: '',
//                stockplace_id_to: ''
//            };
            
//            vm.model = {
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlacesFrom: [],
//                selectListStockPlacesTo: [],
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await requisitionsService.getSetting())[0];
//            }
            
//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }
            
//            async function loadStockPlaces(id) {
//                switch (id) {
//                    case 'businessco_no_from':
//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from, true) !== true) return;

//                        return vm.model.selectListStockPlacesFrom = await logisticService.listStocks({
//                            businessco_no: vm.model.setting.businessco_no_from,
//                            add_all: 'ALL'
//                        });
//                        break;
//                    case 'businessco_no_to':
//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_to, true) !== true) return;

//                        return vm.model.selectListStockPlacesTo = await logisticService.listStocks({
//                            businessco_no: vm.model.setting.businessco_no_to,
//                            add_all: 'ALL'
//                        });
//                        break;
//                    default:
//                        break;
//                };
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true
//                    && utilityService.validateParmsValue(vm.model.setting.businessco_no_from) === true
//                    && utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) === true
//                    && utilityService.validateParmsValue(vm.model.setting.businessco_no_to) === true
//                    && utilityService.validateParmsValue(vm.model.setting.stockplace_id_to) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS
            
//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });
                
//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;
                
//                let variableValue = null;
                
//                switch (id) {
//                    case 'businessco_no_from':
//                    case 'stockplace_id_from':
//                    case 'businessco_no_to':
//                    case 'stockplace_id_to':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;
                        
//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }
                
//                return rememberService.remember(variableNames[id], variableValue);
//            }
            
//    		// #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no_from':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no_from) !== true) return;

//                        vm.model.setting.businessco_no_from = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from, true) !== true) return;

//                        rememberFunc('businessco_no_from');
//                        loadStockPlaces('businessco_no_from');
//                        break;
//                    case 'stockplace_id_from':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id_from) !== true) return;

//                        vm.model.setting.stockplace_id_from = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from, true) !== true) return;

//                        rememberFunc('stockplace_id_from');
//                        loadGrid();
//                        break;
//                    case 'businessco_no_to':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no_to) !== true) return;

//                        vm.model.setting.businessco_no_to = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_to, true) !== true) return;

//                        rememberFunc('businessco_no_to');
//                        loadStockPlaces('businessco_no_to');
//                        break;
//                    case 'stockplace_id_to':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id_to) !== true) return;

//                        vm.model.setting.stockplace_id_to = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_to, true) !== true) return;

//                        rememberFunc('stockplace_id_to');
//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();

//                return Promise.all([
//                    loadStockPlaces('businessco_no_from'),
//                    loadStockPlaces('businessco_no_to')
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
